import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import React from 'react';
import { useSelector } from 'react-redux';
import WholePortionPredriedPreparationSingleTraySection from './WholePortionPredriedPreparationSingleTraySection';
import WholePortionWetPreparationSingleTraySection from './WholePortionWetPreparationSingleTraySection';
let WholePortionPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const stateBeforePreparation: StateOfMaterial = useSelector(
    createWorksheetSelector!('Preparation.StateBeforePreparation')
  );
  //Wet Material - wet and dry masses are measured, moisture content is not calculated .
  const wetMaterial = stateBeforePreparation === StateOfMaterial.Moist;

  //Pre-dried material - dry mass is measured, no wet mass or moisture content test
  const preDriedMaterial = stateBeforePreparation === StateOfMaterial.OvenDry;

  return (
    <PageSection heading="Sieve Portion Preparation">
      {wetMaterial && <WholePortionWetPreparationSingleTraySection />}
      {preDriedMaterial && <WholePortionPredriedPreparationSingleTraySection />}
    </PageSection>
  );
};
WholePortionPreparationSection = withInjectedProps(WholePortionPreparationSection);

export { WholePortionPreparationSection };
export default WholePortionPreparationSection;
